<template>
  <div class="loginBox">
    <div class="loginTitle" @click="$router.push({ path: '/' });">招商百晓生管理后台</div>
    <div class="loginMain clearfix">
      <h1>{{loginText}}</h1>
      <div class="dingdingCode" id="login_container"></div>
    </div>
  </div>
</template>

<script>
import * as dd from 'dingtalk-jsapi';
import util from '@assets/js/util';
import jsonwebtoken from 'jsonwebtoken';
import store from '../../store';
const getAuthCodeUrl = '/sail/v1/admin_user/auth_code';
const loginUrl = '/sail/v1/admin_user/login';
const getOptionListUrl = '/sail/v1/other/dicts';
let systemLan = 'en-US';
const navigatorLan = navigator.language; // 获取浏览器的语言设置
if (navigatorLan.indexOf('zh') == 0) {
  systemLan = 'zh-CN'; // 汉语默认设置成中文简体
}
if (localStorage.getItem('locale')) {
  systemLan = localStorage.getItem('locale');
}
export default {
  name: 'login',
  data () {
    return {
      loginText: '加载中...',
      localeLanguage: systemLan === 'en-US' ? 'EN-US' : '中文',
      showErrorMessage: false,
      ErrorMessage: '',
      mobileNumber: '', // 用户手机号
      code: '', // 手机验证码
      codeText: 60,
      codeStatus: true, // 是否可以获取验证码
      timer: null,
      loginStatus: true // 防止二次提交
    };
  },
  beforeDestroy () {
    clearInterval(this.timer); // 清空timmer
  },
  methods: {
    getParamsForUrl () {
      // 获取 hash 字符串
      const hashStr = window.location.hash;

      const hashIndex = hashStr.indexOf('?');
      // 去除 # 符号
      const hashParams = hashStr.slice(hashIndex + 1);
      // 解析成对象形式
      const paramsObj = {};

      hashParams.split('&').forEach(param => {
        const [key, value] = param.split('=');
        paramsObj[key] = value;
      });
      return paramsObj;
    },
    loginSend (code, type) {
      const registerUrl = '/login/adminregister';
      this.$ajax.post(registerUrl, { code, type }).then(data => {
        const { status, msg } = data.data;
        if (status == 200) {
          this.$Modal.success({
            title: '申请成功',
            content: msg || '请联系管理员做审批处理',
            onOk: () => {
            }
          });
          this.loginText = '请联系管理员做审批处理';
        } else {
          window.location.href = '/#/register';
          window.location.reload();
          // this.$router.push({ path: '/register' });
        }
      });
    },
    dingdingLogin () {
      // 参考老版钉钉扫码登录 https://open.dingtalk.com/document/isvapp/scan-qr-code-to-log-on-to-third-party-websites
      this.loginText = '钉钉扫码申请管理员';
      /*
      * 解释一下goto参数，参考以下例子：
      */
      const appid = process.env.VUE_APP_DING_APPID;
      const url = encodeURIComponent(window.location.href);
      const goto = encodeURIComponent(`https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${appid}&response_type=code&scope=snsapi_login&state=web&redirect_uri=${url}`);
      const obj = window.DDLogin({
        id: 'login_container', // 这里需要你在自己的页面定义一个HTML标签并设置id，例如<div id="login_container"></div>或<span id="login_container"></span>
        goto, // 请参考注释里的方式
        style: 'border:none;background-color:#FFFFFF;',
        width: '365',
        height: '400'
      });

      const handleMessage = (event) => {
        const { origin } = event;
        console.log('origin', origin);
        if (origin == 'https://login.dingtalk.com') { // 判断是否来自ddLogin扫码事件
          const loginTmpCode = event.data;
          console.log('loginTmpCode', loginTmpCode);
          // 获取到loginTmpCode后就可以在这里构造跳转链接进行跳转了
          window.location.href = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${appid}&response_type=code&scope=snsapi_login&state=web&redirect_uri=${url}&loginTmpCode=${loginTmpCode}`;
        }
      };
      if (typeof window.addEventListener != 'undefined') {
        window.addEventListener('message', handleMessage, false);
      } else if (typeof window.attachEvent != 'undefined') {
        window.attachEvent('onmessage', handleMessage);
      }
    },
    // 登录
    login () {
      if (!/DingTalk/.test(navigator.userAgent)) {
        const params = this.getParamsForUrl();
        console.log('params', params);
        if (window.location.href.indexOf('code') == -1) {
          this.dingdingLogin();
        } else {
          if (params.code && params.state == 'web') {
            this.loginSend(params.code, params.state);
          } else {
            this.$Modal.error({
              title: '提示',
              content: '参数异常，请重新扫码登录'
            });
          }
        }
        return;
      }
      const _that = this;
      dd.ready(() => {
        // dd.ready参数为回调函数，在环境准备就绪时触发，jsapi的调用需要保证在该回调函数触发后调用，否则无效。
        dd.runtime.permission.requestAuthCode({
          corpId: process.env.VUE_APP_DING_CORPID,
          onSuccess (result) {
            const { code } = result;
            _that.loginSend(code);
          },
          onFail (err) {
            alert(JSON.stringify(err));
          }
        });
      });
    }
  },
  mounted () {
    this.login();
  }
};
</script>

<style lang="less">
h1{ text-align: center;}
html {
  overflow: auto !important;
}
.loginBox {
  background: url('../../assets/images/login/loginBg.jpg') no-repeat center;
  background-size:100% 100%;
  background-color: #e6e6e6;
  padding-top: 40px;
  width: 100%;
  height: 100%;
  min-height: 660px;
  position: absolute;
  font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑';
}

.loginTitle {
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
  line-height: 80px;
  font-style: normal;
  font-size: 52px;
  color: #1c4cff;
  text-align: center;
}

.loginFormTitle {
  font-size: 29px;
  color: #000000;
  font-style: normal;
  text-align: center;
  margin-bottom: 40px;
  letter-spacing: 4px;
}
.loginMain{
  /* width: 900px;*/
  height: 480px;
  /* border-radius:5px; */
  /* box-shadow:0px 10px 20px #bfc5da; */
  margin: 0 auto;
  margin-top:40px;
  /* background:#fff */
}
.loginLeft{
  float:left;
  background:#e0e0e0;
  border-top-left-radius: 5px;
  border-bottom-left-radius:5px;
  padding:130px 61px;
  height: 481px;
  box-sizing: border-box;
}
.loginLeft img{
  display: block;
  width: 328px;
}
.loginForm {
  float: right;
  position: relative;
  /* margin: 80px auto; */
  width: 450px;
  height: 481px;
  padding: 50px 25px;
  text-align: center;
  background: #fff;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.loginGroup{
  margin:20px;
  padding:10px 5px;
  border-bottom:1px solid #1c4cff;
  text-align:left;
  position: relative;
}
.loginIcon {
  position: absolute;
  width: 30px;
  height: 30px;
  text-align: center;
}
.loginControl{
  border:none;
  outline: none;
  margin-left:40px;
  font-size:20px;
  line-height:30px;
  vertical-align:middle;
  width: 260px;
}
.showMsg {
  position: absolute;
  font-size: 12px;
  color: #fff;
  text-align: center;
  line-height: 20px;
  width: 100%;
  color:red;
  left: 0;
  top: 100px;
}

.loginBtn {
  display: block;
  width: 168px;
  line-height:48px;
  border-radius:24px;
  text-align: center;
  background:#2d5afc;
  color:#fff;
  border:none;
  outline: none;
  margin:50px auto;
  font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑';
  cursor: pointer;
  font-size: 18px;
}
.langLink {
  color: #1c4cff;
  font-size: 14px;
}
.codeBtn {
  position: absolute;
  right: 0;
  font-size: 14px;
  background-color: #2d5afc;
}

.codeBtnDisable {
  width: 90px;
  text-align: center;
  position: absolute;
  right: 0;
  height: 30px;
  border-radius: 3px;
  border: 1px solid #ccc;
  color: #ccc;
}
.clearfix{zoom:1;}
.clearfix:after{ clear:both; display:block; content:"."; height:0; visibility:hidden;}
.dingdingCode { margin: 20px auto; width: 365px;}
</style>
